import { useCallback, useState } from 'react';

/**
 * Obras que el usuario excluye de los informes por partida de Vivienda Gerencia
 * (p. ej. casas entregadas cuyo costo no se llevaba por partida en el ERP anterior).
 * Se guarda en localStorage de este navegador para no tener que volver a marcarlas;
 * si el almacenamiento no está disponible, funciona igual solo durante la sesión.
 */
const KEY = 'adelante-bi-obras:vivienda-obras-excluidas:v1';

function leer(): Set<string> {
  try {
    const raw = localStorage.getItem(KEY);
    const arr: unknown = raw ? JSON.parse(raw) : [];
    return new Set(Array.isArray(arr) ? arr.filter((x): x is string => typeof x === 'string') : []);
  } catch {
    return new Set();
  }
}

export function useObrasExcluidas(): [Set<string>, (nuevas: Set<string>) => void] {
  const [excluidas, setExcluidas] = useState<Set<string>>(leer);
  const guardar = useCallback((nuevas: Set<string>) => {
    setExcluidas(nuevas);
    try {
      localStorage.setItem(KEY, JSON.stringify([...nuevas]));
    } catch {
      /* sin almacenamiento: se mantiene solo en memoria */
    }
  }, []);
  return [excluidas, guardar];
}
